var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _g3, _path9, _g4, _path10, _g5, _path11, _g6, _path12, _g7, _path13, _g8, _path14, _g9, _path15, _g10, _path16, _g11, _path17, _path18, _path19, _g12, _path20, _g13, _path21, _g14, _path22, _g15, _path23, _g16, _path24, _g17, _path25, _g18;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 23,
    viewBox: "0 0 150 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.941 19.1107H134.67V5.87846H130.941V19.1107Z",
    fill: "#FF4785"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 0,
    width: 5,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.627 2.22689C130.626 3.4576 131.598 4.45717 132.799 4.45784C133.999 4.45852 134.973 3.46233 134.974 2.23163C134.975 1.00024 134.003 0.00135305 132.802 1.37204e-06C131.602 -0.00135031 130.628 0.996189 130.627 2.22689Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.211 6.87397H137.39V-2.41612H128.211V6.87397Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 6,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.302 6.56917C103.148 7.72621 101.81 9.99297 101.81 12.4828C101.81 16.1614 104.73 19.1547 108.317 19.1547C110.884 19.1547 113.218 17.6009 114.263 15.1963C114.682 14.2318 114.26 13.1018 113.319 12.672C112.38 12.2422 111.277 12.6754 110.856 13.6405C110.41 14.6678 109.414 15.3314 108.317 15.3314C106.786 15.3314 105.54 14.0534 105.54 12.4828C105.54 11.4197 106.111 10.4512 107.032 9.95715C107.944 9.46717 108.296 8.31148 107.819 7.37612C107.485 6.72326 106.836 6.35155 106.165 6.35155C105.873 6.35155 105.577 6.42183 105.302 6.56917Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3948 21.5708H116.842V3.93542H99.3948V21.5708Z",
    fill: "#FF4785"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.629 22.1432H149.358V5.90414H145.629V22.1432Z",
    fill: "#FF4785"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8259 22.1432H50.5545V5.90414H46.8259V22.1432Z",
    fill: "#FF4785"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.439 19.1107H120.168V5.90414H116.439V19.1107Z",
    fill: "#FF4785"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2993 19.1107H74.0286V5.90414H70.2993V19.1107Z",
    fill: "#FF4785"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 5,
    width: 13,
    height: 15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.793 12.4828C88.793 16.1614 91.7112 19.1547 95.2993 19.1547C97.4721 19.1547 99.4929 18.049 100.706 16.1958L97.608 14.0656C97.0903 14.8583 96.2272 15.3314 95.2993 15.3314C93.7678 15.3314 92.5216 14.0534 92.5216 12.4828C92.5216 10.9121 93.7678 9.63477 95.2993 9.63477C96.2346 9.63477 97.1017 10.1153 97.6194 10.9209L100.734 8.817C99.524 6.93479 97.4924 5.81087 95.2993 5.81087C91.7112 5.81087 88.793 8.80416 88.793 12.4828Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.377 21.5708H103.15V3.39474H86.377V21.5708Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 14,
    height: 13
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45679 5.36212L6.96618 9.3293V9.32998C7.59539 8.91096 8.30367 8.71023 9.00316 8.71023C10.2359 8.71023 11.4443 9.32998 12.1634 10.4681C12.7088 11.3305 12.8946 12.3598 12.6845 13.3654C12.5013 14.2454 12.037 15.0145 11.3612 15.5687L17.2775 11.2081C17.0957 10.0416 16.6794 8.91569 16.0333 7.89449C14.8181 5.97105 12.944 4.64708 10.757 4.16859C10.1703 4.04018 9.57898 3.97733 8.99235 3.97733C7.39399 3.97733 5.82874 4.44771 4.45679 5.36212Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04077 17.9848H19.6937V1.5612H2.04077V17.9848Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 9,
    width: 14,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4306 9.54557L27.7246 9.3293C27.6219 9.39688 27.5246 9.4692 27.4306 9.54557ZM21.5049 13.9142C21.6813 15.0631 22.0881 16.1925 22.7437 17.2312C24.3454 19.7636 27.0366 21.143 29.7812 21.143C31.3404 21.143 32.9178 20.6969 34.3202 19.7656L31.8114 15.7957C30.9693 16.3574 29.9671 16.5446 28.9837 16.331C28.0024 16.1161 27.161 15.522 26.6142 14.6583C25.5545 12.9802 25.9323 10.7655 27.4306 9.54557L21.5049 13.9142Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0889 23.5591H36.7364V6.91318H19.0889V23.5591Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 36,
    height: 19
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1242 5.42496L24.6376 5.78316L17.2777 11.2081L11.3614 15.5686C11.2634 15.6497 11.1607 15.7254 11.0539 15.7964C10.8599 15.9248 10.6578 16.0296 10.4517 16.1181C8.94932 16.7595 7.18808 16.329 6.13174 15.0354C6.0351 14.9158 5.94183 14.7914 5.85735 14.6583L1.98682 17.2312C3.20265 19.1547 5.07676 20.4779 7.2631 20.9564C7.40908 20.9882 7.55506 21.0159 7.70104 21.0402C7.84297 21.0632 7.98625 21.0821 8.12817 21.0984C8.13155 21.099 8.13426 21.099 8.13764 21.0997C8.4296 21.1308 8.72089 21.147 9.01217 21.147C10.6186 21.147 12.2082 20.6638 13.6505 19.7028C13.6545 19.7001 13.6586 19.6974 13.6626 19.694L14.1377 19.3446L21.5051 13.9142L27.7242 9.32929C27.8188 9.26644 27.9154 9.21034 28.0134 9.15695C28.0418 9.14141 28.0709 9.12654 28.0992 9.11234C28.1756 9.07315 28.2547 9.03665 28.3331 9.00286C28.3581 8.99204 28.3831 8.98056 28.4081 8.97109C28.5122 8.92919 28.6176 8.89202 28.7244 8.86026C28.7339 8.85688 28.744 8.85485 28.7535 8.85215C28.8521 8.82376 28.9508 8.80078 29.0515 8.78051C29.0758 8.77578 29.0995 8.77105 29.1245 8.76699C29.2225 8.74942 29.3225 8.73523 29.4225 8.72644C29.434 8.72509 29.4462 8.72306 29.4577 8.72171C29.5577 8.7136 29.6591 8.70887 29.7598 8.70887C29.7699 8.70887 29.7814 8.70954 29.7922 8.70954C29.8652 8.71022 29.9382 8.71698 30.0105 8.72171C30.0639 8.72576 30.118 8.72644 30.1714 8.73252C30.2984 8.74672 30.4255 8.76699 30.5519 8.7947C30.6742 8.82106 30.7945 8.85417 30.9128 8.89202C31.0243 8.92852 31.1331 8.97109 31.2399 9.01705C31.2737 9.03192 31.3068 9.04949 31.3399 9.06571C31.4115 9.0995 31.4832 9.13397 31.5521 9.17182C31.5906 9.19345 31.6271 9.21575 31.6643 9.23873C31.7272 9.2759 31.7887 9.31442 31.8495 9.35565C31.8867 9.38133 31.9225 9.40769 31.959 9.43404C32.0184 9.47797 32.0752 9.52326 32.1313 9.56921C32.1658 9.59692 32.1982 9.62598 32.232 9.65504C32.2888 9.70708 32.3442 9.76048 32.3989 9.81522C32.4267 9.8436 32.4557 9.87064 32.4814 9.90037C32.5429 9.96661 32.6017 10.0355 32.6585 10.1065C32.676 10.1275 32.6943 10.1477 32.7112 10.1687C32.7848 10.2647 32.8551 10.3633 32.9207 10.4674L36.7912 7.89516V7.89448C35.8795 6.45224 34.5974 5.34656 33.0903 4.68289C32.5889 4.46121 32.0617 4.2882 31.5149 4.16925C30.9344 4.04287 30.3491 3.97934 29.7672 3.97934C28.158 3.97934 26.5691 4.46257 25.1242 5.42496Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.429199 23.5632H39.2068V1.56322H-0.429199V23.5632Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 5,
    width: 14,
    height: 15
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8835 12.4828C46.8835 16.1614 49.8018 19.1547 53.3899 19.1547C56.9772 19.1547 59.8968 16.1614 59.8968 12.4828C59.8968 8.80416 56.9772 5.81087 53.3899 5.81087C49.8018 5.81087 46.8835 8.80416 46.8835 12.4828ZM50.6122 12.4828C50.6122 10.9121 51.8584 9.63477 53.3899 9.63477C54.9213 9.63477 56.1669 10.9121 56.1669 12.4828C56.1669 14.0534 54.9213 15.3314 53.3899 15.3314C51.8584 15.3314 50.6122 14.0534 50.6122 12.4828Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4675 21.5708H62.3131V3.39474H44.4675V21.5708Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 5,
    width: 14,
    height: 15
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0356 12.4828C61.0356 16.1614 63.9546 19.1547 67.5426 19.1547C71.13 19.1547 74.0496 16.1614 74.0496 12.4828C74.0496 8.80416 71.13 5.81087 67.5426 5.81087C63.9546 5.81087 61.0356 8.80416 61.0356 12.4828ZM64.7649 12.4828C64.7649 10.9121 66.0112 9.63477 67.5426 9.63477C69.0741 9.63477 70.3203 10.9121 70.3203 12.4828C70.3203 14.0534 69.0741 15.3314 67.5426 15.3314C66.0112 15.3314 64.7649 14.0534 64.7649 12.4828Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6196 21.5708H76.4652V3.39474H58.6196V21.5708Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 5,
    width: 14,
    height: 15
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.316 12.4828C136.316 16.1614 139.235 19.1547 142.823 19.1547C146.41 19.1547 149.329 16.1614 149.329 12.4828C149.329 8.80416 146.41 5.81087 142.823 5.81087C139.235 5.81087 136.316 8.80416 136.316 12.4828ZM140.045 12.4828C140.045 10.9121 141.291 9.63477 142.823 9.63477C144.354 9.63477 145.6 10.9121 145.6 12.4828C145.6 14.0534 144.354 15.3314 142.823 15.3314C141.291 15.3314 140.045 14.0534 140.045 12.4828Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.9 21.5708H151.745V3.39474H133.9V21.5708Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 5,
    width: 13,
    height: 14
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.221 10.1484C101.86 11.1378 102.351 12.2388 103.315 12.6085C104.28 12.9761 105.353 12.4753 105.715 11.4859C106.117 10.3782 107.163 9.63477 108.317 9.63477C109.849 9.63477 111.095 10.9121 111.095 12.4828C111.095 13.6574 110.408 14.6961 109.345 15.1307C108.388 15.522 107.921 16.6344 108.302 17.6144C108.593 18.3632 109.293 18.8194 110.035 18.8194C110.265 18.8194 110.498 18.7755 110.724 18.6836C113.214 17.6658 114.824 15.2314 114.824 12.4828C114.824 8.80349 111.905 5.81087 108.317 5.81087C105.615 5.81087 103.166 7.55386 102.221 10.1484Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.686 21.2356H117.24V3.39474H99.686V21.2356Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 5,
    width: 13,
    height: 15
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.421 12.1638H120.149C120.149 9.81319 122.279 9.74493 122.521 9.74493C123.145 9.74493 123.71 9.95377 124.111 10.3316C124.569 10.7621 124.801 11.4068 124.801 12.2469V19.0235H128.53V12.2469C128.53 8.09453 125.508 5.92171 122.521 5.92171C119.565 5.92171 116.421 8.1094 116.421 12.1638Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.005 21.4397H130.946V3.50558H114.005V21.4397Z",
    fill: "#FF4785"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3826 5.93253L82.5363 22.1628L84.2726 17.6401L79.418 5.93253H75.3826Z",
    fill: "#FF4785"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0008 5.93253L78.7412 22.1851H82.5259L88.7855 5.93253H85.0008Z",
    fill: "#FF4785"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 7,
    height: 13
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98671 17.2305L5.85725 14.6583C5.64571 14.3244 5.4923 13.9689 5.39227 13.604C5.29225 13.239 5.24764 12.8646 5.25508 12.4936C5.27805 11.2575 5.88023 10.0518 6.9663 9.32929L4.45691 5.36143C0.584346 7.93639 -0.523356 13.26 1.98671 17.2305Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.77368 19.6467H9.38173V2.94598H-1.77368V19.6467Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 7,
    width: 8,
    height: 13
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9206 10.4674V10.4681C33.4667 11.3311 33.6518 12.3598 33.4423 13.3661C33.2328 14.3731 32.6536 15.2355 31.8115 15.7957L34.3202 19.7656C36.197 18.5173 37.4872 16.5959 37.9536 14.3542C38.0198 14.0365 38.0657 13.7175 38.0968 13.3992C38.1191 13.1769 38.1327 12.9545 38.1374 12.7322C38.1381 12.7112 38.1394 12.6903 38.1394 12.6693C38.1631 10.9878 37.7035 9.33674 36.7911 7.89517L32.9206 10.4674Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3955 22.1811H40.557V5.47905H29.3955V22.1811Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 14,
    height: 13
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45679 5.36212L6.96618 9.3293V9.32998C7.59539 8.91096 8.30367 8.71023 9.00316 8.71023C10.2359 8.71023 11.4443 9.32998 12.1634 10.4681C12.7088 11.3305 12.8946 12.3598 12.6845 13.3654C12.5013 14.2454 12.037 15.0145 11.3612 15.5687L17.2775 11.2081C17.0957 10.0416 16.6794 8.91569 16.0333 7.89449C14.8181 5.97105 12.944 4.64708 10.757 4.16859C10.1703 4.04018 9.57898 3.97733 8.99235 3.97733C7.39399 3.97733 5.82874 4.44771 4.45679 5.36212Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04077 17.9848H19.6937V1.5612H2.04077V17.9848Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 9,
    width: 14,
    height: 13
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4306 9.54557L27.7246 9.3293C27.6219 9.39688 27.5246 9.4692 27.4306 9.54557ZM21.5049 13.9142C21.6813 15.0631 22.0881 16.1925 22.7437 17.2312C24.3454 19.7636 27.0366 21.143 29.7812 21.143C31.3404 21.143 32.9178 20.6969 34.3202 19.7656L31.8114 15.7957C30.9693 16.3574 29.9671 16.5446 28.9837 16.331C28.0024 16.1161 27.161 15.522 26.6142 14.6583C25.5545 12.9802 25.9323 10.7655 27.4306 9.54557L21.5049 13.9142Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0889 23.5591H36.7364V6.91318H19.0889V23.5591Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 36,
    height: 19
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1242 5.42496L24.6376 5.78316L17.2777 11.2081L11.3614 15.5686C11.2634 15.6497 11.1607 15.7254 11.0539 15.7964C10.8599 15.9248 10.6578 16.0296 10.4517 16.1181C8.94932 16.7595 7.18808 16.329 6.13174 15.0354C6.0351 14.9158 5.94183 14.7914 5.85735 14.6583L1.98682 17.2312C3.20265 19.1547 5.07676 20.4779 7.2631 20.9564C7.40908 20.9882 7.55506 21.0159 7.70104 21.0402C7.84297 21.0632 7.98625 21.0821 8.12817 21.0984C8.13155 21.099 8.13426 21.099 8.13764 21.0997C8.4296 21.1308 8.72089 21.147 9.01217 21.147C10.6186 21.147 12.2082 20.6638 13.6505 19.7028C13.6545 19.7001 13.6586 19.6974 13.6626 19.694L14.1377 19.3446L21.5051 13.9142L27.7242 9.32929C27.8188 9.26644 27.9154 9.21034 28.0134 9.15695C28.0418 9.14141 28.0709 9.12654 28.0992 9.11234C28.1756 9.07315 28.2547 9.03665 28.3331 9.00286C28.3581 8.99204 28.3831 8.98056 28.4081 8.97109C28.5122 8.92919 28.6176 8.89202 28.7244 8.86026C28.7339 8.85688 28.744 8.85485 28.7535 8.85215C28.8521 8.82376 28.9508 8.80078 29.0515 8.78051C29.0758 8.77578 29.0995 8.77105 29.1245 8.76699C29.2225 8.74942 29.3225 8.73523 29.4225 8.72644C29.434 8.72509 29.4462 8.72306 29.4577 8.72171C29.5577 8.7136 29.6591 8.70887 29.7598 8.70887C29.7699 8.70887 29.7814 8.70954 29.7922 8.70954C29.8652 8.71022 29.9382 8.71698 30.0105 8.72171C30.0639 8.72576 30.118 8.72644 30.1714 8.73252C30.2984 8.74672 30.4255 8.76699 30.5519 8.7947C30.6742 8.82106 30.7945 8.85417 30.9128 8.89202C31.0243 8.92852 31.1331 8.97109 31.2399 9.01705C31.2737 9.03192 31.3068 9.04949 31.3399 9.06571C31.4115 9.0995 31.4832 9.13397 31.5521 9.17182C31.5906 9.19345 31.6271 9.21575 31.6643 9.23873C31.7272 9.2759 31.7887 9.31442 31.8495 9.35565C31.8867 9.38133 31.9225 9.40769 31.959 9.43404C32.0184 9.47797 32.0752 9.52326 32.1313 9.56921C32.1658 9.59692 32.1982 9.62598 32.232 9.65504C32.2888 9.70708 32.3442 9.76048 32.3989 9.81522C32.4267 9.8436 32.4557 9.87064 32.4814 9.90037C32.5429 9.96661 32.6017 10.0355 32.6585 10.1065C32.676 10.1275 32.6943 10.1477 32.7112 10.1687C32.7848 10.2647 32.8551 10.3633 32.9207 10.4674L36.7912 7.89516V7.89448C35.8795 6.45224 34.5974 5.34656 33.0903 4.68289C32.5889 4.46121 32.0617 4.2882 31.5149 4.16925C30.9344 4.04287 30.3491 3.97934 29.7672 3.97934C28.158 3.97934 26.5691 4.46257 25.1242 5.42496Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.429199 23.5632H39.2068V1.56322H-0.429199V23.5632Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 7,
    height: 13
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98671 17.2305L5.85725 14.6583C5.64571 14.3244 5.4923 13.9689 5.39227 13.604C5.29225 13.239 5.24764 12.8646 5.25508 12.4936C5.27805 11.2575 5.88023 10.0518 6.9663 9.32929L4.45691 5.36143C0.584346 7.93639 -0.523356 13.26 1.98671 17.2305Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.77368 19.6467H9.38173V2.94598H-1.77368V19.6467Z",
    fill: "#FF4785"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_3110_39440",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 7,
    width: 8,
    height: 13
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9206 10.4674V10.4681C33.4667 11.3311 33.6518 12.3598 33.4423 13.3661C33.2328 14.3731 32.6536 15.2355 31.8115 15.7957L34.3202 19.7656C36.197 18.5173 37.4872 16.5959 37.9536 14.3542C38.0198 14.0365 38.0657 13.7175 38.0968 13.3992C38.1191 13.1769 38.1327 12.9545 38.1374 12.7322C38.1381 12.7112 38.1394 12.6903 38.1394 12.6693C38.1631 10.9878 37.7035 9.33674 36.7911 7.89517L32.9206 10.4674Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_3110_39440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3955 22.1811H40.557V5.47905H29.3955V22.1811Z",
    fill: "#FF4785"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcLogo);
export default __webpack_public_path__ + "static/media/tcLogo.1060f5443385cf3132fd16f5a6645bed.svg";
export { ForwardRef as ReactComponent };